export default "__VITE_ASSET__C8l7HFXK__"